import Trix from "trix"

// Configurar atributos antes de qualquer inicialização
addExtraTrixAttributes()

addEventListener("trix-initialize", function (event) {
    new RdmTrixExtensions(event.target)
})

class RdmTrixExtensions {
  constructor(element) {
    this.element = element
    
    this.insertAlignButtons()
  }

  insertAlignButtons() {
    if (this.buttonGroupTextTools) {
      this.buttonGroupTextTools.insertAdjacentHTML("beforebegin", this.alignButtonsTemplate)
    }
  }

  get buttonGroupTextTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=text-tools]")
  }

  get buttonGroupBlockTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=block-tools]")
  }

  get toolbarElement() {
    return this.element.toolbarElement
  }

  get alignButtonsTemplate() {
    return `
      <span class="trix-button-group trix-button-group--alignment-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-align-left" data-trix-attribute="alignLeft" title="Align Left" tabindex="-1">Align Left</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-align-center" data-trix-attribute="alignCenter" title="Align Center" tabindex="-1">Align Center</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-align-right" data-trix-attribute="alignRight" title="Align Right" tabindex="-1">Align Right</button>
      </span>
    `
  }
}

function addExtraTrixAttributes() {
  // Configurar os atributos de bloco para alinhamento
  Trix.config.blockAttributes.alignLeft = {
    tagName: 'align-left',
    parse: true,
    nestable: false,
    exclusive: true,
  };
  
  Trix.config.blockAttributes.alignCenter = {
    tagName: 'align-center',
    parse: true,
    nestable: false,
    exclusive: true,
  };
  
  Trix.config.blockAttributes.alignRight = {
    tagName: 'align-right',
    parse: true,
    nestable: false,
    exclusive: true,
  };
}

// Web Components para alinhamento
class BaseAlignElement extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.style.display = 'block';
    this.style.width = '100%';
  }
}

class AlignCenter extends BaseAlignElement {
  connectedCallback() {
    super.connectedCallback();
    this.style.textAlign = 'center';
  }
}

class AlignLeft extends BaseAlignElement {
  connectedCallback() {
    super.connectedCallback();
    this.style.textAlign = 'left';
  }
}

class AlignRight extends BaseAlignElement {
  connectedCallback() {
    super.connectedCallback();
    this.style.textAlign = 'right';
  }
}

// Registrar os elementos customizados
if (!customElements.get("align-center")) {
  customElements.define("align-center", AlignCenter);
}
if (!customElements.get("align-left")) {
  customElements.define("align-left", AlignLeft);
}
if (!customElements.get("align-right")) {
  customElements.define("align-right", AlignRight);
}